import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
    const token = localStorage.getItem("token");
    // ou cookie / context, selon ton login

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    return children;
}
